import * as React from "react";

import { cn } from "@/features/common/style/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, readOnly, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border border-input px-3 py-1 text-base shadow-sm transition-[border-color,box-shadow] duration-fast file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 focus-visible:border-primary/50 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          // 入力エラーの箇所が一目で分かるよう赤枠にする（aria-invalid で指定）
          "aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive/40",
          readOnly && "bg-muted/50 text-muted-foreground cursor-not-allowed",
          className,
        )}
        ref={ref}
        readOnly={readOnly}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
